import React from "react";
import { Flame } from "lucide-react";

const W = 1080;
const H = 1350;

export default function SushiAd() {
  return (
    <div className="min-h-screen w-full bg-black flex items-start justify-center">
      <div
        data-testid="sushi-ad-standalone"
        className="relative overflow-hidden flex flex-col"
        style={{
          width: W,
          height: H,
          backgroundImage: "url(/sushi-fusion-hero.jpg)",
          backgroundSize: "cover",
          backgroundPosition: "center 42%",
        }}
      >
        {/* Overlays */}
        <div
          className="absolute inset-0"
          style={{
            background:
              "linear-gradient(to bottom, rgba(0,0,0,0.82) 0%, rgba(0,0,0,0.25) 26%, rgba(0,0,0,0) 45%, rgba(0,0,0,0.55) 72%, rgba(0,0,0,0.93) 100%)",
          }}
        />
        {/* Rasta stripe */}
        <div className="absolute top-0 left-0 right-0 flex" style={{ height: 10 }}>
          <div className="flex-1" style={{ background: "#E03A2F" }} />
          <div className="flex-1" style={{ background: "#F6B93B" }} />
          <div className="flex-1" style={{ background: "#1F8A44" }} />
        </div>

        {/* Header */}
        <div className="relative flex items-center justify-center gap-4 mt-12">
          <Flame className="w-9 h-9 text-[#FF3B30]" />
          <span className="font-['Anton'] text-5xl tracking-widest uppercase text-white">
            Smokey <span className="text-[#FF3B30]">AF</span> Barbecue
          </span>
        </div>
        <p className="relative text-center font-['Outfit'] uppercase tracking-[0.5em] text-[#F6B93B] mt-4 text-xl">
          Island Meets Smoke
        </p>

        {/* Headline */}
        <h1
          className="relative font-['Anton'] uppercase text-white text-center leading-[0.88] mt-6"
          style={{ fontSize: 96, textShadow: "0 4px 30px rgba(0,0,0,0.9)" }}
        >
          Sushi…
          <br />
          <span className="text-[#FF3B30]">but make it BBQ AF</span>
        </h1>

        <div className="flex-1" />

        {/* Item plates */}
        <div className="relative px-14 pb-6 space-y-4">
          {[
            { name: "Rastafarian Jerk Chicken Sushi Roll", desc: "Jerk chicken · mango · spicy jerk aioli" },
            { name: "BBQ Sushi", desc: "Smoked pulled pork · Japanese BBQ dip" },
          ].map((it) => (
            <div
              key={it.name}
              className="flex items-center justify-between gap-6 bg-black/70 border border-white/15 px-8 py-5"
              style={{ backdropFilter: "blur(6px)" }}
            >
              <div>
                <div className="font-['Anton'] uppercase tracking-tight text-white leading-none" style={{ fontSize: 40 }}>
                  {it.name}
                </div>
                <div className="font-['Outfit'] uppercase tracking-[0.25em] text-zinc-300 mt-2" style={{ fontSize: 17 }}>
                  {it.desc}
                </div>
              </div>
              <div
                className="bg-[#FF3B30] text-white font-['Anton'] px-6 py-3 rotate-2 flex-shrink-0"
                style={{ fontSize: 46 }}
              >
                $10
              </div>
            </div>
          ))}
        </div>

        {/* Footer */}
        <div className="relative border-t border-white/20 mx-14 pt-5 pb-10 flex items-center justify-between">
          <div className="font-['Anton'] uppercase tracking-widest text-white" style={{ fontSize: 26 }}>
            Southern Style · 648 N Broad St, Fremont NE
          </div>
          <div className="font-['Outfit'] uppercase tracking-[0.3em] text-[#F6B93B]" style={{ fontSize: 18 }}>
            Dine in · Order online
          </div>
        </div>
      </div>
    </div>
  );
}
